import { useEffect, useRef, useState } from 'react';
import { BLOCK_LABELS, addBlockToPage, blockKinds, pageInfo, resolveDesign, type BlockKind, type ProjectDoc } from '@cal/engine';
import { edit, useEditor } from './store';

/** Add a block of a kind to the current page (first free grid cells) and select it. */
export function addBlockKind(doc: ProjectDoc, page: string, kind: BlockKind) {
  const info = pageInfo(doc, page);
  const r = addBlockToPage(doc, page, info.design, kind, resolveDesign(doc, page).elements);
  edit(() => r.doc, `add:${r.id}`);
  useEditor.setState({ selected: r.id, view: 'single' });
}

/** "+ Add block" in the canvas toolbar: always available, whatever is selected. */
export function AddBlockMenu({ doc }: { doc: ProjectDoc }) {
  const page = useEditor((s) => s.page);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('mousedown', close);
    window.addEventListener('keydown', esc);
    return () => { window.removeEventListener('mousedown', close); window.removeEventListener('keydown', esc); };
  }, [open]);
  const kinds = blockKinds(pageInfo(doc, page).design);
  return (
    <div className="menu-wrap" ref={ref}>
      <button className="btn sm primary" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(!open)}>+ Add block</button>
      {open && (
        <div className="menu" role="menu" aria-label="Block type to add">
          {kinds.map((k) => (
            <button key={k} role="menuitem" onClick={() => { setOpen(false); addBlockKind(doc, page, k); }}>{BLOCK_LABELS[k]}</button>
          ))}
        </div>
      )}
    </div>
  );
}
